import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import moment from 'moment';
import { resetConsultationNote, DefaultPatientInfoLabels } from '../../../../../../../redux/features/doctor/Dashboard/consultation/consultationNote';

interface Props { 
    item: any
}; 

const TabRow: React.FC<Props> = ({ item }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId, consultationNoteId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const updatedTitle = useAppSelector(state => state.consultationNote.updatedTitle); 

    const [formattedTitle, setFormattedTitle] = useState(''); 

    // -- 

    const handleNote = () => { 
      const translatedLabels: DefaultPatientInfoLabels = {
          name: t('pdf.label.name', 'Name:'),
          dob: t('pdf.label.dob', 'DOB:'),
          healthCard: t('pdf.label.healthCard', 'Health Card:'),
      };
      dispatch(resetConsultationNote({ labels: translatedLabels })); 
      navigate(`/consultation/${consultationId}/note/${item?._id}`);
    }; 

    // -- 

    const formatTitle = (title: string) => { 
      if (title) { 
        const MAX_LEN = 15;
        if (title.length > MAX_LEN) {
          setFormattedTitle(title.slice(0, MAX_LEN - 3) + '...');
        } else {
          setFormattedTitle(title);
        }
      } else { 
        setFormattedTitle(String(t('new'))); 
      }; 
    }; 

    // -- 

    useEffect(() => { 
      if (item) { 
        formatTitle(item?.title); 
      }; 
    },[item]); 

    // -- 

    useEffect(() => { 
      if (updatedTitle) { 
        if (consultationNoteId == item?._id) { 
          formatTitle(updatedTitle); 
        }; 
      }; 
    },[updatedTitle]); 
    
    // -- 

    return (
      <Box 
        onClick={handleNote}
        sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'space-evenly',
            width: 140,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: 30,      
            marginTop: 1, 
            fontSize: 12, 
            borderTopLeftRadius: 10, 
            borderTopRightRadius: 10,          
            zIndex: (consultationNoteId == item?._id) ? 1 : 0,    
            cursor: (consultationNoteId == item?._id) ? 'default' : 'pointer',   
            backgroundColor: (consultationNoteId == item?._id) ? colors?.container : 'rgb(210, 210, 210)',
            boxShadow: (consultationNoteId == item?._id) ? '4px 0px 2px -2px rgba(0, 0, 0, 0.2)' : 'none',
            '&:hover': { backgroundColor: (consultationNoteId == item?._id) ? colors?.container : 'rgb(190, 190, 190)' }
      }}>{formattedTitle}
      </Box>
  );
};

export default TabRow;